
import { IMarker } from "redux/utils/interfaces";
import { reduxActionType, stationsReducerType } from "redux/utils/types";

const initialState = {
	stations: [] as IMarker[],
	stationId: "" as string,
	stationIndex: 0 as number,
};

export const stationsReducer = (
	state = initialState,
	action: reduxActionType
): stationsReducerType => {
	switch (action.type) {
	case "SET_MAP_DATA": {
		return {
			...action.payload,			
		};
	}
	default:
		return state;
	}
};

export const stationIdReducer = (
	state = {stationId: "" as string},
	action: reduxActionType
):any => {
	switch (action.type) {
		case "SET_StationId": {
			return {stationId: action.payload};
		}
		default:
			return state;
		}
}

export const stationIndexReducer = (
	state = {stationIndex: 0 as number},
	action: reduxActionType
):any => {
	switch (action.type) {
		case "SET_StationIndex": {
			return {stationIndex: action.payload};
		}
		default:
			return state;
		}
}
